import { Tooltip, Typography } from '@mui/material'
import React from 'react'

import Icon from 'components/Icon'
import theme from 'theme'

export const TestSuiteCompositionInputFieldHelpText: React.FC<{
  errorMessage?: string
}> = ({ errorMessage }) => {
  if (errorMessage) {
    return (
      <Typography color="error" component="span">
        {errorMessage}
      </Typography>
    )
  }

  return (
    <>
      Search for a Recommended/Shared scenario or an existing scenario from the
      teams you belong to
      <Tooltip
        arrow
        placement="right"
        title={
          "Can't find a scenario? It may belong to a team you are not a part of. Ask a team manager from the team to share the scenario with the company."
        }
      >
        <Icon
          css={{
            color: theme.colors.steel[1],
            marginLeft: theme.space[1]
          }}
          icon="solidCircleInfo"
        />
      </Tooltip>
    </>
  )
}
